//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {wxShareConfig} from '../js/common/utils'
import configInfo from "../configInfo.js"
	export default{
		created(){
			this.matchId = this.$route.query.matchId;
			this.screenHeight = window.innerHeight;
		},
		data(){
			return{
				matchId:'',
				referee:null,
				assistantReferee1:null,
				assistantReferee2:null,
				fourthOfficial:null,
				matchSupervisor:null,
				leagueName:null,
				homeTeamName:null,
				vistingTeamName:null,
				location:null,
				time:null,
				screenHeight:800,
				backgroundImg: require('../assets/img/AdvertisementBackGroundImg.svg')
			}
		},
		mounted(){
			this.hagkHttp(this.hagkApi.getMatchInfoById(this.matchId), {})
			.then((res) => {
				if(res){
					this.referee = res.referee;
					this.assistantReferee1 = res.assistantReferee1;
					this.assistantReferee2 = res.assistantReferee2;
					this.fourthOfficial = res.fourthOfficial;
					this.matchSupervisor = res.matchSupervisor;
					this.leagueName = res.leagueName;
					this.homeTeamName = res.homeTeamName;
					this.vistingTeamName = res.vistingTeamName;
					this.location = res.location;
					var timeStr = res.time;
					if(res.time != null && res.time.length > 15){
						var year = res.time.substring(0,4);
						var month = res.time.substring(5,7);
						var day = res.time.substring(8,10);
						var hour = res.time.substring(11,16);
						this.time = year+"."+month+"."+day+" "+hour;
					}
				}

				document.title = "比赛预告";
          			var realPath = window.location.href;
          			/*var fullPath;
          			if(realPath.indexOf('from=') == -1){
          				fullPath = realPath + '&from=singlemessage';
          			} else {
          				fullPath = realPath;
          			}*/
                	// var fullPath=realPath.replace("&from=singlemessage","");
	        		//var fullPath = realPath.substring(0,realPath.indexOf('/match_info'))+'/match_info_share?matchId='+this.matchId;
		            var shareImg = window.location.origin + configInfo.routerBase + "static/logo.png";
		            var title = this.leagueName;
		            var desc = "主队："+this.homeTeamName+'\r\n客队：'+this.vistingTeamName;
		            
		            wxShareConfig({
                            title: title,
                            desc: desc,
                            link: realPath,
                            imgUrl: shareImg,
                            type: 'link',
                            dataUrl: ''
                        }, () => {
                        }, () => {
                        });
			},(error) => {
				console.log(error);
				window.alert('比赛信息获取失败！');
			})
		}
	}




// WEBPACK FOOTER //
// ./src/views/matchInfoShare.vue